module.exports = __webpack_public_path__ + "static/img/news74_5.bd7c44d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/activity/news74/news74_5.webp
// module id = C25y
// module chunks = 0